import React, {useState, useEffect, useRef, useContext} from 'react';
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import classes from './EncuentraMentor.module.css';
import GlobalContext from '../../../context/GlobalContext';
import {getPublicCategories} from "../../../helpers/Category.helper";
import {getLevels, getCampus} from "../../../helpers/Register.helper";
import {getPublicMentors} from "../../../helpers/Mentors.helper";
import {getStudentInfo} from "../../../helpers/Token.helper";
import {createMentorship} from "../../../helpers/Mentorship.helper";
import { isEmpty } from 'rxjs/operators';


const EncuentraMentor = () => {

    let history = useHistory();
    const {setLoading} = useContext(GlobalContext);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const message = params.get('mensaje');
    const dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    const [dataMentores, setDataMentores] = useState([]);
    const [isHidden, setIsHidden] = useState(true);
    const [categories, setCategories] = useState([]);
    const [levels, setLevels] = useState([]);
    const [mentors, setMentors] = useState([]);
    const [mentorRequest, setMentorRequest] = useState({});
    const [campus, setCampus] = useState([]);
    const [student, setStudent] = useState({});
    const [modalToggle, setModalToggle] = useState(false);
    const [modalHeader, setModalHeader] = useState('');
    const [modalBody, setModalBody] = useState('');
    const [modalRedirect, setModalRedirect] = useState(false);

    const day = useRef();
    const category = useRef();
    const level = useRef();
    const mensaje = useRef();

    const tConvert = time => {
        if(/AM/i.test(time) || /PM/i.test(time)){
            return time;
        }

        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) { // If time format correct
            time = time.slice(1);  // Remove full string match value
            time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
            return time.join(''); // return adjusted time or original string
        }else{
            time = time > 12 ? time - 12 + ':00 PM' : time + ':00 AM';
            return time;
        }
    }

    useEffect( () => {
        setLoading(true);
        getStudentInfo(message).then(r => {
            if (r.autorizacion != 'False'){
                setStudent(r);
            }
            else{
                showModal(
                    'Ha ocurrido un error al cargar los datos del alumno.',
                    r.mensaje,
                    false
                );
            }
        }).catch(e=>{
            showModal(
                'Ha ocurrido un error al cargar los datos del alumno.',
                e,
                false
            );
        });

        getPublicCategories().then(d => {setCategories(d); setLoading(false);}).catch(e=>{
            setLoading(false);
            showModal(
                'Ha ocurrido un error al cargar las categorías.',
                e,
                false
            );
        });
        getLevels().then(d => {setLevels(d); setLoading(false);}).catch(e=>{
            setLoading(false);
            showModal(
                'Ha ocurrido un error al cargar los niveles.',
                e,
                false
            );
        });
        getCampus().then(c => {setCampus(c); setLoading(false);}).catch(e=>{
            setLoading(false);
            showModal(
                'Ha ocurrido un error al cargar los campus.',
                e,
                false
            );
        });
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setLoading(true);
        console.log(day.current.value + category.current.value + level.current.value);
        getPublicMentors(day.current.value, category.current.value, level.current.value).then(r => {
            setLoading(false);
            if(r.length > 0){
                const fill = filtrateMentors(r);
                console.log(fill);
                setMentors(fill);
            }else{
                showModal(
                    "No se encontró ningún mentor.",
                    "No se ha encontrado ningún mentor que coincida con los parámetros de búsqueda.",
                    false
                );
            }
        }).catch(error=>{
            setLoading(false);
            showModal(
                'Ha ocurrido un error al buscar mentores.',
                error,
                false
            );
        });
    }

    const filtrateMentors = (mentors) => {
        let filtratedMentors = [];
        if(mentors.length > 0){
            mentors.forEach((mentor) => {
                let index = filtratedMentors.findIndex(m => m.idMentorVoluntario == mentor.idMentorVoluntario);
                if(index >= 0){
                    filtratedMentors[index].horario.push({
                        sHoraInicio: mentor.sHoraInicio,
                        sHoraFinal: mentor.sHoraFinal
                    })
                }else{
                    mentor.horario = [{
                        sHoraInicio: mentor.sHoraInicio,
                        sHoraFinal: mentor.sHoraFinal
                    }]

                    filtratedMentors.push(mentor);
                }
            })

            return filtratedMentors;
        }
    }

    const handleSubmit = (e, mentorship) => {
        e.preventDefault();
        console.log(mentorship);
        const body = {
            sNombreAlumno: student.nombreCompleto,
            correoAlumno: student.correoAlumno,
            iMatricula: student.idAlumno,
            idCampus: mentorship.idCampus,
            idNivel: levels.filter(l => l.sNivel === mentorship.sNivel)[0].idNivel,
            idCategoria: mentorship.idCategoriaNumero,
            idMentorVoluntario: mentorship.idMentorVoluntarioNumero,
            sSolicitud: '',
            sCorreo: mentorship.sCorreo
        }

        console.log(body);
        setMentorRequest(body);
        setIsHidden(false);
    }

    const handleClick = () => {
        const msg = mensaje.current.value;
        if(msg.length <= 50){
            showModal(
                "Favor de indicar en qué te gustaría que te ayude tu mentor.",
                'Debes escribir un mensaje para tu mentor de por lo menos 50 caracteres.',
                false
            )
            return;
        }

        setLoading(true);
        const Request = {
            ...mentorRequest,
            sSolicitud: msg
        };
        createMentorship(Request).then(async resp => {
            setLoading(false);
            showModal(
                "¡Felicidades tu solicitud de mentoría se ha registrado exitosamente!",
                'Te confirmamos que desde este momento ya hemos notificado al mentor que seleccionaste y pronto se pondrá en contacto contigo, Si tienes alguna duda estamos para apoyarte en: <a href="mailto:soymentor@tecmilenio.mx">soymentor@tecmilenio.mx</a>.',
                true
            )
        }).catch(error=>{
            setLoading(false);
            const message = (error.error) ? error.error : error.message;
            if(message){
                showModal(
                    "Ha ocurrido un error.",
                    message,
                    false
                );
            }else{
                showModal(
                    "Ha ocurrido un error.",
                    "Ha ocurrido un error inesperado, intente de nuevo",
                    false
                );
            }
        });
    }

    const showModal = (header, body, redirect) => {
        setModalHeader(header);
        setModalBody(body);
        setModalToggle(true);
        setModalRedirect(redirect);
    }

    const handleClickModal = (redirect) => {
        setModalToggle(!modalToggle);
        if(redirect){
            window.scrollTo(0,0);
            window.location.reload();
        }
    }

    return(
        <Container>
            <Row>
                <Col className={classes.col}>
                    <h1>Encuentra tu mentor</h1>
                </Col>
            </Row>
            {
                (isHidden)?
                <>
                <Row>
                    <Col className={classes.col}>
                        <div className={classes.inputsContainer}>
                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="disponibilidad">Día de disponibilidad</label>
                                <select id="disponibilidad" className={classes.input} ref={day}>
                                    {
                                        dias.map((item, index)=>(
                                            <option value={index + 1} key={item}>{item}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="categoria">Categoría</label>
                                <select id="categoria" className={classes.input} ref={category}>
                                    {
                                        categories.map((item, index)=>(
                                            <option value={item.idCategoria} key={item}>{item.sCategoria}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="mentores">Mentores</label>
                                <select id="mentores" className={classes.input}>
                                    <option value="todos">Todos</option>
                                </select>
                            </div>

                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="nivel">Nivel</label>
                                <select id="nivel" className={classes.input} ref={level}>
                                    {
                                        levels.map((item, index)=>(
                                            <option value={item.idNivel} key={item}>{item.sNivel}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className={classes.searchContainer} onClick={handleSearch}>
                                <span className={classes.search}>
                                    <span>Buscar</span>
                                    <i className="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
                {
                    (typeof mentors === 'object' && mentors.length > 0) &&
                    <>
                        <Row>
                            <Col className={classes.col}>
                                <div>
                                    <span className={classes.subtitle}>{mentors.length} mentores que imparten la mentoría</span>
                                </div>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "100px"}}>
                            {
                                mentors.map((item, index) => (
                                    <div key={item.id} className="col-xs-1 col-md-4">
                                        <div className={"card " + classes.card}>
                                            <span className={classes.nombre}>{item.sNombre}</span>
                                            <div>
                                                <span>{item.sPuesto}</span>
                                                <span>{campus.find(obj=>{return obj.idCampus == item.idCampus}).sCampus}</span>
                                            </div>
                                            <span className={classes.mensaje}>{item.sMotivos}</span>
                                            <div className={classes.horariosContainer}>
                                                <span className={classes.horariosText}>Horarios: </span>
                                                <div className={classes.horariosTagContainer}>
                                                    {
                                                        item.horario.map((horario, index)=>(
                                                            <span key={index} className={classes.horario}>{tConvert(horario.sHoraInicio)} a {tConvert(horario.sHoraFinal)}</span>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            <button onClick={(e) => {handleSubmit(e, item)}}>Solicitar</button>
                                        </div>
                                    </div>
                                ))
                            }
                        </Row>
                    </>
                }
                </>
                :
                <Container style={{marginBottom: '50px'}}>
                    <Row>
                        <Col>
                            <form>
                                <div className={classes.inputContainer}>
                                    <label className={classes.text} htmlFor="mensaje">En qué te gustaría que te ayude tu mentor?</label>
                                    <textarea id="mensaje" className={classes.input} ref={mensaje}/>
                                </div>

                                <div className={classes.saveButtons}>
                                    <input type="button" onClick={handleClick} className={classes.buttonAddDisp} value="Solicitar"/>
                                    <span className={classes.regresar} onClick={() => setIsHidden(true)}>Ir a mis mentorías</span>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Container>
            }

            {/* MODAL */}
            <div>
                <Modal size="lg" isOpen={modalToggle} >
                    <ModalHeader toggle={()=>{handleClickModal(modalRedirect)}}>
                        {modalHeader}
                    </ModalHeader>
                    <ModalBody dangerouslySetInnerHTML={{__html: modalBody}}></ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={()=>{handleClickModal(modalRedirect)}} >
                            Aceptar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </Container>
    );
}
export default EncuentraMentor;
